<template>

    <transition name="sideMenu">
        <div class="sideMenuBar blurrable" :class="{'blurred': $root.modalWindowOpen}">
            <router-link to="/scenario/drug-enforcement">
                <div class="label">
                    <div class="subtitle" v-html="drug_enforcement.subtitle"/>
                    <div class="title" v-html="drug_enforcement.title"/>
                </div>
            </router-link>

            <router-link to="/scenario/expeditionary">
                <div class="label">
                    <div class="subtitle" v-html="expeditionary.subtitle"/>
                    <div class="title" v-html="expeditionary.title"/>
                </div>
            </router-link>

            <router-link to="/scenario/military-base">
                <div class="label">
                    <div class="subtitle" v-html="military_base.subtitle"/>
                    <div class="title" v-html="military_base.title"/>
                </div>
            </router-link>

            <router-link to="/scenario/disaster-relief">
                <div class="label">
                    <div class="subtitle" v-html="disaster_relief.subtitle"/>
                    <div class="title" v-html="disaster_relief.title"/>
                </div>
            </router-link>

            <router-link to="/scenario/airbase">
                <div class="label">
                    <div class="subtitle" v-html="airbase.subtitle"/>
                    <div class="title" v-html="airbase.title"/>
                </div>
            </router-link>

    </div>
    </transition>

</template>

<script>
export default {
    name: 'ScenarioNavigationMenu',

    computed: {
        scenarioText() {
            return this.$root.scenarioText
        },

        drug_enforcement() {
            return this.scenarioText.drug_enforcement
        },

        expeditionary() {
            return this.scenarioText.expeditionary
        },

        military_base() {
            return this.scenarioText.military_base
        },

        disaster_relief() {
            return this.scenarioText.disaster_relief
        },

        airbase() {
            return this.scenarioText.airbase
        },
    }
}
</script>

<style lang="scss" scoped>
.sideMenuBar {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    
    position: absolute;
    z-index: 20;
    right: 0;
    top: 0;
    height: 100%;
    min-width: 5rem;
}

a {
    color: $colour__primary1;
    text-transform: uppercase;
    height: 20%;
    background-color: $colour__primary2;
    margin-bottom: 1px;
    transition: all .3s ease;
    position: relative;
    &:last-child {
        margin-bottom: 0;
    }
    &:hover {
        text-decoration: none;
    }
    &.router-link-exact-active, &.router-link-active {
        transform: translateX(4.5rem);
        background-color: $colour__accent1;
        cursor: default;
    }
}

.label {
    position: absolute;
    top: 100%;
    left: 1.2rem;
    transform-origin: top left;
    width: calc((100vh - 5.4rem) / 5);
    transform: rotate(-90deg);
    .subtitle {
        font-size: 0.8rem;
    }
    .title {
        font-size: 1.2rem;
    }
}

.inactive {
    cursor: not-allowed;
    opacity: 0.3;
}

// TRANSITIONS

.sideMenu {
    &-enter-active, &-leave-active {
        transition: all .3s ease;
    }
    &-enter-active {
        transition-delay: .9s;
    }
    &-enter, &-leave-to {
        transform: translateX(5rem);
        opacity: 0;
    }
}
</style>
